import { z } from 'zod';
export const AgentModelSchema = z.enum([
    'gpt-5.6-sol',
    'gpt-5.6-terra',
    'gpt-5.6-luna',
    'gpt-6-luna',
    'gpt-6.1-sol',
    'gemini-3.5-flash',
]);
//# sourceMappingURL=model.js.map